import Frame from "../../Frames/Basic";
import { Stack, Alert, IconButton, Typography} from "@mui/material";
import { useEffect, useState } from "react";
import Address from "../../Inputs/Address";
import { LoadingButton } from "@mui/lab";
import LockIcon from '@mui/icons-material/Lock';
import CheckIcon from '@mui/icons-material/Check';
import Loader from "../../Tools/Loader";
import API from "../../../services/API/Indents";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Detail from "./Detail";
import BackIcon from '@mui/icons-material/ArrowBack';
import Pin from "./Pin";
import { useMemo } from "react";
import Invoice from "./Invoice";

export default function Index(){

    const navigate = useNavigate()
    const {uuid} = useParams()
    const [params] = useSearchParams()


    const [indent, setIndent] = useState(null)
    const [status, setStatus] = useState('loading')

    const statusIs = s => status === s

    useEffect(() => {

        const errors = {
            401: 'unauthorized',
            403: 'pin-check',
            500: 'error'
        }

        API.get(uuid)
            .then(r => {
                setIndent(r.data)
                setStatus('ready')
            })
            .catch(e => setStatus(
                errors[e.response?.status] || 'error' 
            ))
        

    }, [uuid])


    const handlePinSubmit = pin => {

        setStatus('pin-submit')

        API.get(uuid, pin)
            .then(r => {
                setIndent(r.data)
                setStatus('ready')
            })
            .catch(e => setStatus('pin-error'))

    }

    const handleSubmit = e => {
        e.preventDefault()

        setStatus('submit')

        let data = {...indent, url: {
            success: window.location.href + '/validate' + (indent.pin ? `/${indent.pin}` : ''),
            cancel: window.location.href
        }};

        API.confirm(data, indent.pin)
            .then(r => handleSuccess(r.data))
            .catch(e => handleError(e))
        
    }

    
    const handleSuccess = data => {
        console.log(data)

        if(data?.stripe?.url){
            window.location.href = data?.stripe?.url || '/';
        }else{
            navigate(`/indents/${data.uuid}/validate`)
        }
        
    }

    const handleError = e => {
        console.log(e?.response?.data)
        setStatus('error')
    }

    
    const readOnly = useMemo(() => {

        return indent?.completed || params.has('readonly')

    }, [params, indent])

    
    const indentIs = status => indent?.status?.id === status
    

    return <Frame>

        <Stack>


            {statusIs('loading') &&
                <Loader />
            }


            {statusIs('error') && 
                <Alert severity='error'>Une erreur s'est produite. Veuillez réessayer ultérieurement.</Alert>
            }


            {statusIs('unauthorized') && 
                <Alert severity='error'>Vous n'êtes pas autorisé à accéder à cette ressource.</Alert>
            }


            {status.startsWith('pin') && 
                <Pin 
                    onSubmit={handlePinSubmit}
                    loading={statusIs('pin-submit')}
                    error={statusIs('pin-error')}
                />
            }


            {['ready','submit'].includes(status) && 
            
                <Stack spacing={3} sx={{maxWidth: 800}}>

                    <Stack direction='row' justifyContent='space-between' alignItems='center'>

                        <Typography variant='h2'>Récapitulatif de la commande</Typography>

                        <IconButton onClick={() => navigate(-1)}>
                            <BackIcon />
                        </IconButton>

                    </Stack>


                    <Detail indent={indent} />


                    {indentIs('paid') && <>
                        <Alert severity='success'>Commande payée</Alert>

                        <Invoice indent={indent}/>
                    </>}

                    {indentIs('validated') &&
                        <Alert severity='success'>Commande validée</Alert>
                    }

                    {indentIs('expired') &&
                        <Alert severity='error'>Commande expirée</Alert>
                    }
                    

                    {!readOnly && 
                    
                        <form onSubmit={handleSubmit}>

                            <Stack direction='column' spacing={3}>

                                <Typography variant='h5'>Confirmez vos coordonnées :</Typography>

                                <Address
                                    value={indent.user}
                                    onChange={value => setIndent({...indent, user: value})}
                                    required
                                />


                                <LoadingButton
                                    type='submit'
                                    variant='contained'
                                    startIcon={indent.free ? <CheckIcon /> : <LockIcon />}
                                    loading={statusIs('submit')}
                                    size='large'
                                    sx={{alignSelf: 'end'}}
                                >
                                    {indent.amount > 0 ? 
                                        `Payer ${indent.amount.toLocaleString()}€` : 
                                        'Confirmer'
                                    }
                                </LoadingButton>
                                
                            </Stack>

                        </form>

                    }

                </Stack>
            }

        </Stack>

    </Frame>
}